import React from 'react';
export function Footer() {
  return <footer className="w-full bg-black border-t border-[#F97316]/20 py-10 px-4" data-id="element-111">
      <div className="max-w-3xl mx-auto text-center" data-id="element-112">
        <div className="text-[#F97316] text-2xl font-black tracking-widest mb-4" data-id="element-113">
          🥊 EDULABS™
        </div>
        <p className="text-gray-400 text-sm leading-relaxed mb-4 max-w-xl mx-auto" data-id="element-114">
          El sistema de clases N°1 para entrenadores de boxeo en habla hispana.
        </p>
        <p className="text-gray-400 text-sm italic mb-6" data-id="element-115">
          Porque enseñar boxeo no debería costarte todas las noches de la
          semana.
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4 text-sm text-gray-300 mb-6" data-id="element-116">
          <span data-id="element-117">📧 soporte.edulabs@gmail.com</span>
          <span className="hidden sm:inline" data-id="element-118">•</span>
          <span data-id="element-119">📲 @edulabs.oficial</span>
          <span className="hidden sm:inline" data-id="element-120">•</span>
          <span data-id="element-121">🌐 www.edulabs.online</span>
        </div>

        <div className="h-px bg-[#F97316]/20 mb-6" data-id="element-122" />
        <p className="text-gray-400 text-xs mb-2" data-id="element-123">
          © EduLabs™ 2026 — Todos los derechos reservados.
        </p>
        <p className="text-gray-500 text-xs mb-6" data-id="element-124">
          Prohibida la reproducción y redistribución sin autorización expresa.
        </p>
        <p className="text-gray-500 text-xs mb-6" data-id="element-125">
          Precios en USD. El cobro se realizará en la moneda local de tu país.
        </p>
      </div>
    </footer>;
}